import { createSelector } from '@reduxjs/toolkit';
import { createDescriptorIfPrivate } from '@ff-os/shared-utils/private-urls';
import { createInputBindings } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { createOptionBindings, selectSizeByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoVariableOptions } from '@gift-variable-plugins/photo-shared/PhotoVariableOptions';

const { createInputSelector, createInputUpdater }
    = createInputBindings<PhotoVariableInput>();

const { createOptionSelector } = createOptionBindings<PhotoVariableOptions>();

export const selectClipById = createSelector([
    createOptionSelector(o => o.clip),
    createInputSelector(i => i.fit),
    selectSizeByVariableId
], (clip, fit, size) => {

    if (fit === 'contain') {
        return;
    }

    if (clip && clip.paths.length > 0) {
        return clip;
    }

    return {
        paths: [`M 0,0 H ${size!.width}V ${size!.height}H 0 Z`],
        width: size!.width,
        height: size!.height
    };
});

export const selectAssetUrlById = createInputSelector(i => i.assetUrl);
export const updateAssetUrlById = createInputUpdater('assetUrl');

export const selectStatusById = createInputSelector(i => i.status);
export const updateStatusById = createInputUpdater('status');

export const selectCropBoxById = createInputSelector(i => i.cropBox);
export const updateCropBox = createInputUpdater('cropBox');

export const selectFileNameById = createInputSelector(i => i.fileName);

export const selectImageWidthById = createInputSelector(i => i.imageWidth);
export const selectImageHeightById = createInputSelector(i => i.imageHeight);

export const selectFilterById = createInputSelector(i => i.filter);
export const updateFilter = createInputUpdater('filter');

export const selectCuidById = createInputSelector(i => i.cuid);

export const selectImageSizeById = createSelector([
    selectImageWidthById,
    selectImageHeightById
], (width, height) => width && height
    ? { width, height }
    : undefined);

export const selectPrivateAssetUrl = createSelector([
    (state: GiftPdpState) => state.auth.jwt,
    selectAssetUrlById
], (jwt, assetUrl) => assetUrl
    ? createDescriptorIfPrivate(assetUrl, jwt)
    : undefined);